import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationErrors } from 'fluentvalidation-ts';
import { EMPTY, catchError, finalize, tap } from 'rxjs';

import { UserLoginModel, AuthService, BaseComponent, RoleProfiles } from '@nstep-common/core';
import { ClientVerifyModel, LoginCardModelValidator, LoginModelValidator } from '@nstep-public/pages';
import { ClientsService } from '@nstep-public/shared';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	standalone: false
})
export class LoginComponent extends BaseComponent implements OnInit {
	verifiedClient: ClientVerifyModel = new ClientVerifyModel();

	loading = false;
	redirectingToClient = false;

	isCardLogin = true;
	isClientConsent = false;
	isTotalClient = false;

	constructor(private clientService: ClientsService,
		private router: Router,
		private route: ActivatedRoute,
		private authService: AuthService) {
		super();

		this.isCardLogin = !this.router.url.endsWith('local');

		if (this.authService.jwt != null) {
			this.isClientConsent = this.verifyClient();

			if (!this.isClientConsent) {
				this.router.navigate(['']);
			}
		}
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	validateLogin(): (model: UserLoginModel) => ValidationErrors<UserLoginModel> {
		return ((model: UserLoginModel) => {
			const validator = this.isCardLogin ? new LoginCardModelValidator() : new LoginModelValidator();
			const validations = validator.validate(model);

			return validations;
		});
	}

	afterLogin() {
		if (this.authService.jwt?.profileId == RoleProfiles.Operator) {
			this.router.navigate(['select-location']);
		}
		else {
			this.isClientConsent = this.verifyClient();

			if (!this.isClientConsent) {
				this.router.navigate(['']);
			}
		}
	}

	verifyClient(): boolean {
		const clientId = this.route.snapshot.queryParamMap.get('clientId') || null;
		if (!clientId) {
			return false;
		}

		this.loading = true;

		const verifyClient = this.clientService.verifyClient(clientId)
			.pipe(
				tap(resp => {
					if (resp) {
						this.verifiedClient = resp;
						this.isTotalClient = this.verifiedClient.name == 'Total';
					}
					else {
						this.router.navigate(['']);
					}
				}),
				catchError(() => {
					this.router.navigate(['']);
					return EMPTY;
				}),
				finalize(() => {
					this.loading = false;
				})
			)
			.subscribe();

		this.subscriptions.push(verifyClient);

		return true;
	}

	consentClient(yes: boolean): void {
		if (!yes) {
			this.redirectingToClient = true;
			window.location.href = this.verifiedClient.loginUrl;
			return;
		}

		this.loading = true;

		const authorizeClient = this.clientService.authorizeClient(this.verifiedClient.id)
			.pipe(
				tap(resp => {
					this.redirectingToClient = true; 
					window.location.href = resp.redirectUrl;
				}),
				catchError(() => {
					this.router.navigate(['']);
					return EMPTY;
				}),
				finalize(() => this.loading = false)
			)
			.subscribe();

		this.subscriptions.push(authorizeClient);
	}
}
